// src/utils/logEvent.js
import { getFunctions, httpsCallable } from 'firebase/functions';

// Write an entry to the tamper-resistant event log (events collection).
// Fire-and-forget by design: logging must never break the action it records,
// so all failures are swallowed after a console warning.
//
//   logEvent('reservation.created', {
//     target: { id: athleteId, email, name },
//     description: 'Reserved a spot in Adult Training (2026-06-30)',
//     metadata: { classId },
//   });
export function logEvent(type, { target, description, metadata } = {}) {
  try {
    const functions = getFunctions();
    const call = httpsCallable(functions, 'logEvent');
    call({ type, target, description, metadata }).catch((e) =>
      console.warn('logEvent failed:', type, e?.message || e)
    );
  } catch (e) {
    console.warn('logEvent unavailable:', e?.message || e);
  }
}
